export function findIndexOrNull<T>(
  array: T[],
  callback: (element: T) => boolean
): number | null {
  const index = array.findIndex(callback);
  return index === -1 ? null : index;
}
